export const API = process.env.REACT_APP_API_URL;
export const WENS_API = process.env.REACT_APP_WENS_API_URL;
